// extracted by mini-css-extract-plugin
export default {"downloadcsv__exemplo_arquivo":"DownloadCSVStyle_downloadcsv__exemplo_arquivo__V00IT"};